export default __webpack_public_path__ + "static/media/single-project-page-03-img12.d1cde4e1.jpg";